var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 20.0088C39.9 31.0049 30.9903 39.9176 19.9983 39.9176C9.00626 39.9176 0.1 31.0049 0.1 20.0088C0.1 9.01272 9.00963 0.1 19.9983 0.1C30.9869 0.1 39.9 9.01274 39.9 20.0088Z",
    fill: "#343A3F",
    fillOpacity: 0.2,
    stroke: "black",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_139_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 20,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.98926H10V29.9893H30V9.98926Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_139_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0014 20.3748C22.8586 20.3748 25.1942 18.0392 25.1942 15.1821C25.1942 12.3249 22.8586 9.98926 20.0014 9.98926C17.1442 9.98926 14.8087 12.3249 14.8087 15.1821C14.8087 18.0392 17.1443 20.3748 20.0014 20.3748ZM28.913 24.5245C28.7769 24.1843 28.5955 23.8669 28.3915 23.5721C27.3484 22.0301 25.7384 21.0097 23.9244 20.7603C23.6976 20.7376 23.4482 20.7829 23.2668 20.919C22.3144 21.6219 21.1806 21.9847 20.0014 21.9847C18.8223 21.9847 17.6885 21.6219 16.7361 20.919C16.5547 20.7829 16.3053 20.7149 16.0785 20.7603C14.2645 21.0097 12.6318 22.0301 11.6114 23.5721C11.4073 23.8669 11.2259 24.207 11.0899 24.5245C11.0219 24.6605 11.0445 24.8192 11.1126 24.9553C11.294 25.2728 11.5207 25.5903 11.7248 25.8623C12.0422 26.2932 12.3824 26.6787 12.7679 27.0415C13.0853 27.3589 13.4481 27.6537 13.811 27.9485C15.6024 29.2864 17.7566 29.9893 19.9788 29.9893C22.201 29.9893 24.3552 29.2863 26.1466 27.9485C26.5094 27.6764 26.8722 27.3589 27.1897 27.0415C27.5525 26.6787 27.9153 26.2932 28.2328 25.8623C28.4595 25.5676 28.6636 25.2728 28.845 24.9553C28.9583 24.8192 28.981 24.6605 28.913 24.5245Z",
    fill: "#343A3F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerProfile);
export default __webpack_public_path__ + "static/media/CustomerProfile.8932ef3878420ded1f31ccff9ea23982.svg";
export { ForwardRef as ReactComponent };